// src/pages/public/SlugRouter.jsx
// Route générique /:slug
// - type "menu"          → MenuRenderer
// - type "google_review" → GoogleReviewRenderer
// - autres types         → PublicPage inchangé (vCard, bio, etc.)

import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import api from '../../lib/axios'
import PublicPage from './PublicPage'
import MenuRenderer from '../../components/layout/MenuRenderer'
import GoogleReviewRenderer from '../../components/layout/GoogleReviewRenderer'
import { normalizeSettings } from '../../lib/normalizeSettings'

// Détecte le type même si l'API ne renvoie pas `type`
function detectKind(p, settings) {
  if (p?.type === 'menu' || p?.type === 'google_review') return p.type
  if (Array.isArray(settings.categories)) return 'menu'
  if (settings.googleUrl !== undefined || settings.ctaLabel !== undefined) return 'google_review'
  return 'other'
}

export default function SlugRouter() {
  const { slug } = useParams()
  const [state, setState] = useState({ status: 'loading', page: null })

  useEffect(() => {
    let cancelled = false
    setState({ status: 'loading', page: null })

    api.get(`/public/pages/${slug}`)
      .then(({ data }) => {
        if (cancelled) return
        const p = data?.data ?? data
        const settings = normalizeSettings(p?.settings)
        const kind = detectKind(p, settings)

        // 🔎 DEBUG — à supprimer une fois que ça fonctionne
        console.log('SLUGROUTER →', { type: p?.type, kind, settingsKeys: Object.keys(settings) })

        if (kind === 'menu' || kind === 'google_review') {
          setState({ status: kind, page: { ...p, settings } })
        } else {
          setState({ status: 'other', page: null })
        }
      })
      .catch(() => {
        // En cas d'erreur, PublicPage gère lui-même le "introuvable"
        if (!cancelled) setState({ status: 'other', page: null })
      })

    return () => { cancelled = true }
  }, [slug])

  if (state.status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f9f9ff]">
        <Loader2 className="w-8 h-8 text-[#006b5f] animate-spin" />
      </div>
    )
  }

  if (state.status === 'menu') return <MenuRenderer page={state.page} />
  if (state.status === 'google_review') return <GoogleReviewRenderer page={state.page} />

  return <PublicPage />
}